import useFetch from '@hooks/useFetch';
import { getCMSHost } from '@utils/api-helper/host';

const CMSHost = getCMSHost();

/**
 * CMS: GET /iconic-pro-add-ons?goalUid={goalUid}
 */
export const getIconicProComboBundleKey = (goalUid) =>
  `${CMSHost}iconic-pro-add-ons?goalUid=${goalUid}`;

/**
 * Supports all CMS empty / filled shapes:
 * - [{ topology_details: [...] }]
 * - [{ topology_details: [] }]
 * - []
 * - camelCased equivalents from useFetch
 */
export const getIconicProComboTopologyDetails = (data) => {
  if (!data) return [];

  const entry = Array.isArray(data) ? data[0] : data;
  if (!entry) return [];

  return entry.topology_details || entry.topologyDetails || [];
};

/**
 * Fetches Iconic Pro combo topologies from CMS.
 * Only fetches when `enabled` is true (selected plan is Iconic Pro).
 *
 * Empty CMS (`[]` or empty topology_details) → hasComboTopologies false → skip combo UI.
 */
const useIconicProComboBundle = (goalUID, enabled = false) => {
  const shouldFetch = Boolean(enabled && goalUID);
  const { data, isLoading, ...rest } = useFetch(
    shouldFetch ? getIconicProComboBundleKey(goalUID) : null,
    { useAuthToken: false }
  );

  if (!enabled || !goalUID) {
    return {
      comboBundle: null,
      topologyDetails: [],
      hasComboTopologies: false,
      isLoading: false,
      ...rest
    };
  }

  const topologyDetails = getIconicProComboTopologyDetails(data);
  return {
    comboBundle: data,
    topologyDetails,
    hasComboTopologies: topologyDetails.length > 0,
    isLoading: shouldFetch ? isLoading : false,
    ...rest
  };
};

export default useIconicProComboBundle;
